// extracted by mini-css-extract-plugin
module.exports = {"article":"TermsPrivacy_article__2o5gW","h1":"TermsPrivacy_h1__co4Md","a":"TermsPrivacy_a__3Sskg","trBackgroundColor":"TermsPrivacy_trBackgroundColor__1j8Of"};